import type {SVGProps} from 'react'
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#1D9089"
      d="M11.446 10.847a.5.5 0 0 0 .708.707l3.195-3.196a.5.5 0 0 0 .005-.712l-3.2-3.2a.5.5 0 0 0-.708.708L13.793 7.5H.8a.5.5 0 0 0 0 1h12.993z"
    />
  </svg>
)
export default SvgArrowRight
